// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from 'store'
import http from './untils/http'
import filters from './untils/filters'
import Vuex from './vuex';
import VueLazyload from 'vue-lazyload'
import icon from '@/components/Common/icon.vue'
import '@/assets/common.less'
import '@/assets/fonts/iconfont.css'
import '@/assets/fonts/iconfont.js'

import { Cell, CellGroup, Icon, Button, Popup, Picker, Loading, Notify, Area, Field, ImagePreview, CountDown,Toast } from 'vant'

import 'moment/locale/zh-cn'

import ClipboardJS from 'clipboard'
Vue.prototype.ClipboardJS = ClipboardJS;

Notify.setDefaultOptions({
  background: '#F96B6F',
  duration: 2000
})

Vue.config.productionTip = false

Vue.use(Icon)
   .use(Button)
   .use(Popup)
   .use(Loading)
   .use(Notify)
   .use(ImagePreview)
   .use(Cell)
   .use(CellGroup)
   .use(Area)
   .use(Field)
   .use(Picker)
   .use(CountDown)
   .use(Toast)

Vue.use(VueLazyload, {
  attempt: 1
});

// 注册全局icon组件
Vue.component('icon', icon)

// 注册全局store
window.store = store

// 自定义指令解决iOS微信浏览器软键盘回收时页面卡住的问题
Vue.directive('ios-bug-fixed', {
  inserted(el) {
    el.__reset_input_handler = () => {
      window.scrollBy(0, -1);
      setTimeout(() => {
        window.scrollBy(0, 1);
      }, 10);
    }
    el.addEventListener('focusout', el.__reset_input_handler);
    el.addEventListener('blur', el.__reset_input_handler);
  },
  unbind(el) {
    el.removeEventListener('focusout', el.__reset_input_handler);
    el.removeEventListener('blur', el.__reset_input_handler);
    delete el.__reset_input_handler;
  }
})

router.beforeEach((to, form, next) => {
  if(to.meta.title) {
    document.title = `${to.meta.title} - 凯诺设计课`
  }
  next()
})

// 注册过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: Vuex,
  components: { App },
  mixins: [http],
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js